import { PaymentTerm } from '@lib/payment-terms';
import { Component, computed, effect, input, output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { RequiredUtilsModule } from '@lib/util';

@Component({
    selector: 'basket-supplier-payment-term',
    imports: [TranslateModule, MatTooltip, MatIconButton, RequiredUtilsModule],
    templateUrl: './basket-supplier-payment-term.component.html',
    styleUrl: './basket-supplier-payment-term.component.scss',
})
export class BasketSupplierPaymentTermComponent {
    // Signal Inputs (seit Angular 17.1+)
    paymentTerm = input<PaymentTerm>();
    paymentTermRequired = input.required<boolean>();
    supplierCompanyId = input.required<string>();
    editable = input(false);
    paymentTermOptions = input<PaymentTerm[] | null | undefined>();

    // Outputs bleiben gleich
    readonly deleted = output<void>();
    readonly updated = output<PaymentTerm>();
    readonly paymentTermSelectionOpened = output<void>();
    readonly paymentTermValidated = output<boolean>();

    // Computed Values
    readonly displayPaymentTerm = computed(() => {
        const opts = this.paymentTermOptions();
        return (this.editable() || !!this.paymentTerm()) && !!opts && opts.length > 0;
    });

    readonly canChangePaymentTerm = computed(() => {
        return this.editable(); // nach dem Fix
    });

    // Automatische Validierung bei Input-Änderungen
    constructor() {
        effect(() => {
            const term = this.paymentTerm();
            const required = this.paymentTermRequired();
            const opts = this.paymentTermOptions();

            const hasOptions = !!opts && opts.length > 0;
            const isValid = !(required && !term && hasOptions);

            this.paymentTermValidated.emit(isValid);
        });
    }

    openPaymentTermSelection(): void {
        this.paymentTermSelectionOpened.emit();
    }

    deleteCurrent(event: any): void {
        event.stopPropagation();
        this.deleted.emit();
    }
}
